export default __webpack_public_path__ + "static/life-1-0c75b5917762a1498cc6737a9eb5b9cd.png";